import { addDays, endOfDay, endOfMonth, endOfWeek, endOfYear, startOfDay, startOfMonth, startOfWeek, startOfYear, subMonths, } from 'date-fns';
/** The quick choices offered in the picker, in order; `custom` is handled separately with a from/to range. */
export const QUICK_PERIODS = [
    'today',
    'yesterday',
    'tomorrow',
    'thisWeek',
    'thisMonth',
    'lastMonth',
    'thisYear',
];
const PERIOD_RANGE = {
    today: () => ({ from: startOfDay(new Date()).getTime(), to: endOfDay(new Date()).getTime() }),
    yesterday: () => ({
        from: startOfDay(addDays(new Date(), -1)).getTime(),
        to: endOfDay(addDays(new Date(), -1)).getTime(),
    }),
    tomorrow: () => ({
        from: startOfDay(addDays(new Date(), 1)).getTime(),
        to: endOfDay(addDays(new Date(), 1)).getTime(),
    }),
    thisWeek: () => ({
        from: startOfWeek(new Date(), { weekStartsOn: 1 }).getTime(),
        to: endOfWeek(new Date(), { weekStartsOn: 1 }).getTime(),
    }),
    thisMonth: () => ({ from: startOfMonth(new Date()).getTime(), to: endOfMonth(new Date()).getTime() }),
    lastMonth: () => {
        const previous = subMonths(new Date(), 1);
        return { from: startOfMonth(previous).getTime(), to: endOfMonth(previous).getTime() };
    },
    thisYear: () => ({ from: startOfYear(new Date()).getTime(), to: endOfYear(new Date()).getTime() }),
};
/** Resolves a period choice to its inclusive epoch-millis range. */
export function getPeriodRange(period) {
    if (period.kind === 'custom') {
        // the picker stores the day it was clicked (midnight); the range is inclusive of the whole last
        // day, like the quick choices, or every row recorded after 00:00 of the "to" day is dropped
        const range = {};
        if (period.from !== undefined)
            range.from = startOfDay(new Date(period.from)).getTime();
        if (period.to !== undefined)
            range.to = endOfDay(new Date(period.to)).getTime();
        return range;
    }
    return PERIOD_RANGE[period.kind]();
}
//# sourceMappingURL=date-range.js.map